import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Template } from './template.model';
import { User } from '../users/user.model';

@Injectable()
export class TemplatesService {

  apiHost = environment.apiHost;
  signedIn: boolean = this.authService.signedIn;
 
  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getTemplates(page: number, search?: string, workflow_id?: number, status?: string, userOnly?: boolean): Observable<any> {
    let query = "?page="+page+"&result_size=10&sort_by=name&sort_order=asc"
    query += "&user_only=" + (userOnly == true)
    if (search != null) {
      query += "&search_str=" + encodeURIComponent(search)
    }
    if (workflow_id != null) {
      query += "&workflow_id=" + workflow_id
    }
    if (status != null) {
      query += "&submitted=" + status;
    }
    return this.http.get(this.apiHost+"/templates"+query).map(
      (data: any) => {
        let total = data.total_templates;
        let templates = data.templates.map((t) => Template.fromRecord(t))
        return {templates: templates, total: total};
      }
    ).catch((error) => {
        console.log("Get templates error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  getTemplate(id): Observable<any> {
    return this.http.get(this.apiHost+"/templates/"+id).map(
      (data: any) => {
        return Template.fromRecord(data);
      }
    ).catch((error) => {
        console.log("Get template error:"); console.log(error);

        switch (error.status) {
          case 401:
            this.authService.signIn()
            return;
          case 403:
            this.authService.accessDenied("You are not authorized to view this template")
            return;
        }

        return Observable.throw(error.status);
      }
    );
  }

  downloadPdf(template_id): Observable<any> {
    let config = {
      headers: new HttpHeaders({'Content-Type': 'application/pdf'}),
      responseType: 'blob' as 'blob'
    }
    return this.http.get(this.apiHost+"/templates/"+template_id+"/pdf", config).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Download pdf error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  sendEmail(template_id, recipients=[]): Observable<any> {
    let query = '?' + recipients.map((r) => "recipients[]=" + encodeURIComponent(r)).join('&')
    return this.http.get(this.apiHost+"/templates/"+template_id+"/preview"+query).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Send email error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  createTemplate(template): Observable<any> {
    let payload = {
      wf_id: template.workflowId,
      template_group_id: template.groupId,
      template_name: template.name,
      template_data: template.data,
      is_public: (template.isPublic === true),
      lock_values: (template.lockValues === true)
    }
    let config = {
      headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'})
    }
    return this.http.post(this.apiHost+"/templates", JSON.stringify(payload), config).map(
      (data: any) => {
        return Template.fromRecord(data);
      }
    ).catch((response) => {
        if (response.status === 401) {
          this.authService.signIn()
        }
        let error = response.error != null ? response.error.message : ''
        return Observable.throw({code: response.status, message: error});
      }
    );
  }

  updateTemplate(template): Observable<any> {
    let payload = {
      wf_id: template.workflowId,
      template_name: template.name,
      template_data: template.data,
      is_public: (template.isPublic === true),
      lock_values: (template.lockValues ===  true)
    }
    let config = {
      headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'})
    }
    return this.http.put(this.apiHost+"/templates/"+template.id, JSON.stringify(payload), config).map(
      (data: any) => {
        return Template.fromRecord(data);
      }
    ).catch((response) => {
        if (response.status === 401) {
          this.authService.signIn()
        }
        let error = response.error != null ? response.error.message : ''
        return Observable.throw({code: response.status, message: error});
      }
    );
  }

  deleteTemplate(template): Observable<any> {
    return this.http.delete(this.apiHost+"/templates/"+template.id).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Delete template error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

  archiveTemplate(template: Template, isArchived: boolean): Observable<any> {
    let url = this.apiHost+"/templates/"+template.id+"/archive"
    let payload = {archived: isArchived}
    return this.http.post(url, JSON.stringify(payload)).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Archive template error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/templates/templates.service.ts